import axios from 'axios';
import moment from 'moment';
function errorHandler(error, reject) {
    console.log(error);
    if (error.response && error.response.data) {
        reject(error.response.data);
    } else {
        reject(error);
    }
}

export default {
    argroup() {
        return new Promise(async (resolve, reject) => {
            try {
                const {
                    data
                } = await axios.get("/payment/postgroup");
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    bankaccount() {
        return new Promise(async (resolve, reject) => {
            try {
                const {
                    data
                } = await axios.get("/bankcashacc/allaccount");
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    byrsemu(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const {
                    data
                } = await axios.get(`arinv/byrsemu/${obj.arinvKey}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    list(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 
                'uraian', 'DimCol', 'DimVal','optiondate', 'tgl1', 'tgl2', 'status', 'nomor', 'customer', 
                'CustName','CustCode','no_kontrak','no_agreement',
                'namabank', 'reference', 'tgldue1', 'tgldue2'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/arsttltt${str}`;
                const { data } = await axios.get(url);
                const { meta, list } = data;
                obj.total = meta.total;
                resolve(list);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    postingbulk(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const url = `/arsttltt/posting-bulk`;
                await axios.post(url,obj);
                resolve(true);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    unpostingbulk(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const url = `/arsttltt/unposting-bulk`;
                await axios.post(url,obj);
                resolve(true);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    prepaid_allocation(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'tgl1', 'tgl2', 'optiondate','no_agreement','no_kontrak','CustCode','CustName','settleuraian'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/arsttltt/prepaid-allocation${str}`;
                const { data } = await axios.get(url);
                const { meta, list } = data;
                obj.total = meta.total;
                resolve(list);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    currency() {
        return new Promise(async (resolve, reject) => {
            try {
                const {
                    data
                } = await axios.get("/currency/cbo");
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    detail(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const {
                    data
                } = await axios.get(`arsttltt/detail/${obj.settleKey}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    detailrekap(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['settleno','pinjamankey','post_date','tglsettl'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const {
                    data
                } = await axios.get(`arsttltt/detail-rekap${str}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    save(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.post("arsttltt", obj);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    
    savePrepaid(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.post("arsttltt/payment-installment-prepaid", obj);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    prepaidsettlauto(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.post("arsttltt/prepaid-settlement-auto", obj);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    remove(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const {
                    data
                } = await axios.delete(`arsttltt/${obj.settleKey}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    potongan() {
        return new Promise(async (resolve, reject) => {
            try {
                const {
                    data
                } = await axios.get("/payment/potongan");
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    posting(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.put(`arsttltt/posting/${obj.settleKey}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    postingUndo(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                await axios.put(`arsttltt/unposting/${obj.settleKey}`);
                resolve();
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },

    printjv(obj = {}) {
        return new Promise(async (resolve, reject) => {
            let url;
            let str = '';
            try {
                str = '?key=' + encodeURIComponent(obj.settleKey);
                url = `/arsttltt/printjv`;

                url += str;
                const { data } = await axios.get(url);
                const link = `${process.env.VUE_APP_BASE_API}/printpreview/pdf/${data.id}`
                resolve(link);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    exportXls(obj = {}) {
        const keys = ['page', 'limit', 'sortBy', 'sortDir', 'uraian', 'DimCol', 'DimVal', 'tgl1', 'tgl2', 'status', 'nomor', 'customer', 
            'namabank', 'reference', 'tgldue1', 'tgldue2','CustName','CustCode','no_kontrak','no_agreement'];

        let str = '';
        for (const key in obj) {
            if (keys.indexOf(key) >= 0 && obj[key]) {
                str += str ? '&' : '?';
                str += key + '=' + encodeURIComponent(obj[key]);
            }
        }

        axios({
            url: `/arsttltt/exportxls${str}`,
            method: 'GET',
            responseType: 'blob', // important
        }).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `prepaid_allocation_${moment().format('YYYYMMDDHHmmss')}.xlsx`);
            document.body.appendChild(link);
            link.click();
            // window.location.assign(url);
        });
    },

    exportXlsPrepaidAlloc(obj = {}) {
        const keys = ['page', 'limit', 'sortBy', 'sortDir', 'uraian', 'DimCol', 'DimVal', 'tgl1', 'tgl2', 'status', 'nomor', 'customer', 'namabank', 'reference', 'tgldue1', 'tgldue2', 'optiondate'];

        let str = '';
        for (const key in obj) {
            if (keys.indexOf(key) >= 0 && obj[key]) {
                str += str ? '&' : '?';
                str += key + '=' + encodeURIComponent(obj[key]);
            }
        }

        axios({
            url: `/arsttltt/exportxlsPrepaidAlloc${str}`,
            method: 'GET',
            responseType: 'blob', // important
        }).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'prepaidallocation.xlsx');
            document.body.appendChild(link);
            link.click();
        });
    },

    exportXlsPrepaidRefund(obj = {}) {
        const keys = ['page', 'limit', 'sortBy', 'sortDir', 'uraian', 'DimCol', 'DimVal', 'tgl1', 'tgl2', 'status', 'nomor', 'customer', 'namabank', 'reference', 'tgldue1', 'tgldue2'];

        let str = '';
        for (const key in obj) {
            if (keys.indexOf(key) >= 0 && obj[key]) {
                str += str ? '&' : '?';
                str += key + '=' + encodeURIComponent(obj[key]);
            }
        }
        axios({
            url: `/arsttltt/exportxlsPrepaidRefund${str}`,
            method: 'GET',
            responseType: 'blob', // important
        }).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'arsttltt_prepaid_refund.xlsx');
            document.body.appendChild(link);
            link.click();
            // window.location.assign(url);
        });
    },
    prepaidrefund(obj){
        return new Promise(async (resolve, reject) => {
            try {
                const {data} = await axios.post(`arsttltt/prepaid-refund`,obj);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    transfer(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const url = `/arsttltt/transfer`;
                const {data} = await axios.post(url,obj);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    transferlist(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir',
                 'tgl1', 'tgl2','uraian','nomor', 'customer','custcode','no_kontrak_from','no_kontrak_to','posting'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/arsttltt/transfer${str}`;
                const { data } = await axios.get(url);
                const { meta, list } = data;
                obj.total = meta.total;
                resolve(list);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    postingtrf(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const url = `/arsttltt/transfer-posting`;
                const {data} = await axios.post(url,obj);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    postingundotrf(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const url = `/arsttltt/transfer-undo-posting`;
                const {data} = await axios.post(url,obj);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
};